var map = {
	"./1_ChloesToverkast_Kleurplaat_Vliegende_Character_Edited_J.png": 13,
	"./2_ChloesToverkast_Kleurplaat_ChloeBloemen_Edited_J.png": 14,
	"./3_ChloesToverkast_Kleurplaat_Tara_Edited_J.png": 15,
	"./4_ChloesToverkast_Kleurplaat_Jet_Edited_J.png": 16,
	"./5_ChloesToverkast_Kleurplaat_tk-logo_Astronout_Edited_J.png": 17,
	"./6_ChloesToverkast_Kleurplaat_MagicPrinses_Edited_J.png": 18,
	"./7_Empty.png": 19
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 134;


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe ^\.\/.*$
// module id = 134
// module chunks = 0